module.exports = __webpack_public_path__ + "static/media/Frame8.3e51eabc.jpg";